
























































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IStatRange } from "@/models/stats";
import StatsCurrencyMixin from "@/mixins/statsCurrencyMixin";
import { DataModules } from "@/store/modules/data";
import { STATS_ALL_CURRENCY_CODE } from "@/data/constants";
import { ICurrency } from "@/models/constants";
import { IImport } from "@/models/imports";

@Component
export default class MRRControls extends Mixins(StatsCurrencyMixin) {
  // Props

  @Prop({ required: true })
  public value!: IStatRange;

  @Prop({ default: null })
  public currency!: string | null;

  @Prop({ default: false })
  public simple!: boolean;

  @Prop({ default: false })
  public time!: boolean;

  @Prop({ default: () => [] })
  public imports!: IImport[];

  @Prop({ default: null })
  public importId!: IImport["id"] | null;

  // Data
  public selectedCurrencyCode = this.currency;

  // Lifecycle methods
  public async created() {
    if (!this.currency) await this.setDefaultCurrency();

    this.$watch("currency", value => {
      this.selectedCurrencyCode = value;
    });
  }

  public handleDateChange() {
    // Custom date doesn't have key
    if (!this.value || !this.$_.get(this.value, "key")) return;
    this.onDatesChange(this.value);
  }

  // Getters
  public get availableCurrencyCodes() {
    // If brand has more than 1 currency include all in the available
    const currencies = this.$_.map(this.brandCurrencies, i => i.code);
    return [STATS_ALL_CURRENCY_CODE, ...currencies];
  }

  public get showCurrencySelect() {
    return this.brandCurrencies.length > 1;
  }

  public get date() {
    return this.value.dateFrom;
  }

  public get importOptions() {
    return [
      {
        label: this.$t("_.all_records"),
        isDisabled: this.$_.isNil(this.importId),
        props: {
          value: null
        }
      },
      {
        label: this.$t("_.all_non_imported_records"),
        props: {
          value: 0
        }
      },
      {
        label: this.$t("_.all_records_from_import") + ":",
        props: {
          custom: true,
          class: "has-text-info"
        }
      },
      ...this.$_.map(this.imports, importObj => ({
        label: importObj.name,
        icon: "file-import",
        props: {
          value: importObj.id
        }
      }))
    ];
  }

  public get selectedImport() {
    return this.$_.find(this.importOptions, ["props.value", this.importId]);
  }

  public async setDefaultCurrency() {
    const currency = await this.getStatsDefaultCurrencyCode();
    this.selectedCurrencyCode = currency;
    this.onCurrencyChange(currency);
  }

  public onCurrencyChange(currency) {
    this.$emit("update:currency", currency);
  }

  public onImportChange(importId: IImport["id"]) {
    this.$emit("update:importId", importId);
  }

  public onDatesChange(stat: IStatRange) {
    this.$emit("input", stat);
  }

  public isAllCode(code: ICurrency["code"]) {
    return code === STATS_ALL_CURRENCY_CODE;
  }

  public openStatDateModal() {
    const { dateFrom } = this.value || {};
    this.$store.dispatch(`data/${DataModules.STATS}/openStatSingleDateModal`, {
      config: {
        props: {
          title: this.$t("_.select_date"),
          defaultDate: dateFrom,
          minDate: null,
          onSelect: async newDate => {
            const result = {
              dateFrom: newDate
            } as IStatRange;
            this.$emit("input", result);
          }
        }
      }
    });
  }
}
